import React, { useState } from 'react';
const faqs = [{
  question: '¿Cuándo recibo el eBook después de comprar?',
  answer: 'En cuanto completes el pago recibirás automáticamente un correo electrónico con el acceso inmediato al libro principal y a los 6 bonos digitales. La entrega es instantánea, sin esperas.'
}, {
  question: '¿El acceso es para siempre?',
  answer: 'Sí. Una vez realizado el pago tendrás acceso permanente al contenido. Podrás descargarlo y consultarlo siempre que lo necesites.'
}, {
  question: '¿En qué formato se entrega el libro?',
  answer: 'El libro y todos los bonos se entregan en formato digital PDF, compatible con móvil, tablet y ordenador. Puedes leerlo desde cualquier dispositivo.'
}, {
  question: '¿Necesito conocimientos previos para aplicarlo?',
  answer: 'No. Está diseñado para que cualquier mujer pueda aplicarlo paso a paso, incluso sin experiencia previa en biohacking o nutrición.'
}, {
  question: '¿Es útil si aún no estoy en menopausia?',
  answer: 'Sí. La guía está pensada tanto para mujeres en premenopausia como en menopausia o postmenopausia, ayudando a prevenir y gestionar cambios hormonales de forma natural.'
}, {
  question: '¿Cómo accedo a los bonos incluidos?',
  answer: 'En el mismo correo de confirmación encontrarás los enlaces de descarga de todos los bonos. Todo queda centralizado para que lo tengas organizado desde el primer momento.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="faq-section" data-id="element-1">
      <div className="faq-title" data-id="element-2">Preguntas Frecuentes</div>

      {faqs.map((faq, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className={`faq-item${isOpen ? ' active' : ''}`} data-id="element-3">
            <div className="faq-question" onClick={() => toggle(index)} data-id="element-4">
              <span data-id="element-5">{faq.question}</span>
              <div className="faq-icon" data-id="element-6">+</div>
            </div>
            <div className="faq-answer" data-id="element-7">{faq.answer}</div>
          </div>;
    })}
    </section>;
}